var Curriculog = Curriculog || {};

Curriculog.Entities = (function ($, _, Backbone, Entities) {

	Entities = Curriculog.CurriculogCollection.extend({
		url: '/rest/entity',
		model: Curriculog.Entity,

		comparator: function (a, b) {
			if (a.get('name').toLowerCase() < b.get('name').toLowerCase())
				return -1;
			if (a.get('name').toLowerCase() > b.get('name').toLowerCase())
				return 1;
			else return 0;
		},

		createEntity: function (relationshipCollection) {
			var view = this;
			var relationshipID = 0;

			this.create({
				entity_type_id: 0,
				name: 'Entity Name',
				status: 'active',
			}, {
				wait: true,

				success: function (model) {
					var newRelationship = relationshipCollection.create({
						entity_id: model.toJSON().id,
						entity_parent_id: null,
					}, {
						wait: true,

						success: function (model) {
							relationshipID = newRelationship.get('id');

							if (relationshipID !== 0) {
								domObject.summaryFlyoutHierarchy('relationship-' + relationshipID, function () {
									hierarchyObject.getFlyout(relationshipID, 'relationship');
								});
							}
						},

						error: function () {

						},
					});

				},

				error: function(result) {
					var errorText = 'An error was encountered when creating the entity.  ';
					errorText += 'The new entity has not been created.  Please try again '
					errorText += 'or contact an administrator.';
					view.showGrowl(errorText);
				}
			});

			return relationshipID;
		},

		getSortedEntities: function(entityIDs) {
			var entities = [];
			for (var i=0; i < entityIDs.length; i++) {
				var entity = this.get(entityIDs[i]);

				// sometimes we have hierarchy_entity_parent records that
				// reference deleted hierarchy_entity records.  This check makes
				// sure we do not try to return any deleted entities.
				if (typeof entity !== 'undefined') {
					entities.push(entity);
				}
			}
			return entities.sort(function (a, b) {
				if (a.get('name').toLowerCase() < b.get('name').toLowerCase())
					return -1;
				if (a.get('name').toLowerCase() > b.get('name').toLowerCase())
					return 1;
				return 0;
			});
		},

		getEntitiesByEntityType: function(entityTypeID) {
			var entities = [];
			for (var i=0; i < this.length; i++) {
				var entity = this.at(i);

				if (entity.get('entity_type_id') === entityTypeID) {
					entities.push(entity);
				}
			}
			return entities;
		},
	});
	return Entities;

})($, _, Backbone, Curriculog.Entities || {});
